(function () {
  const KEY = 'ellaz_wishlist';

  function get() {
    let raw = JSON.parse(localStorage.getItem(KEY) || '[]');
    // migrar formato viejo (array de handles) a objetos
    if (raw.length && typeof raw[0] === 'string') {
      raw = raw.map(h => ({ handle: h }));
      set(raw);
    }
    return raw;
  }
  function set(arr) { localStorage.setItem(KEY, JSON.stringify(arr)); }
  function has(handle) { return get().some(i => i.handle === handle); }

  function refresh() {
    const list = get();
    document.querySelectorAll('[data-wishlist-trigger]').forEach(btn => {
      const active = list.some(i => i.handle === btn.dataset.productHandle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active);
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-trigger]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.productHandle;
    let list = get();

    if (has(handle)) {
      list = list.filter(i => i.handle !== handle);
    } else {
      let variants = [];
      try { variants = JSON.parse(btn.dataset.variants || '[]'); } catch (err) {}
      let optionNames = [];
      try { optionNames = JSON.parse(btn.dataset.optionNames || '[]'); } catch (err) {}
      const firstAvail = variants.find(v => v.available) || variants[0] || {};
      list.push({
        handle: handle,
        productId: btn.dataset.productId,
        title: btn.dataset.productTitle,
        url: btn.dataset.productUrl,
        image: btn.dataset.productImage,
        optionNames: optionNames,
        variants: variants,
        selectedVariantId: firstAvail.id || null
      });
    }
    set(list);
    refresh();
  });

  document.addEventListener('DOMContentLoaded', refresh);
  new MutationObserver(() => refresh()).observe(document.body, { childList: true, subtree: true });

  // exponer para la página de wishlist
  window.EllazWishlist = { get, set, KEY };
})();